export const SET_REPORT = "SET_REPORT";
export const SET_LOADING = "SET_LOADING";
export const SET_AUTH = "SET_AUTH";
